// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as UploadComponent} from './Upload.svg';

import Icon, { TIconProps } from '../Icon';

export const IconUpload = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <UploadComponent/>
  </Icon>
));
